import React from "react";

function SkeletonBlock({ className = "" }) {
  return (
    <div
      className={`animate-pulse rounded-xl bg-gray-200 dark:bg-gray-700 ${className}`}
      aria-hidden="true"
    />
  );
}

export function SettingsSectionSkeleton({
  titleWidth = "w-40",
  rows = 3,
  showDescription = true,
  showHeader = true,
}) {
  return (
    <div
      className="mx-auto w-full max-w-4xl space-y-4"
      aria-busy="true"
      aria-label="Loading settings"
    >
      {showHeader ? (
        <div className="flex flex-col items-center space-y-3">
          <SkeletonBlock className={`h-7 ${titleWidth}`} />
          {showDescription ? <SkeletonBlock className="h-4 w-72 max-w-full" /> : null}
        </div>
      ) : null}

      <div className="space-y-3">
        {Array.from({ length: rows }).map((_, index) => (
          <div
            key={index}
            className="rounded-2xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800"
          >
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0 flex-1 space-y-2">
                <SkeletonBlock className="h-5 w-48 max-w-full" />
                <SkeletonBlock className="h-4 w-full" />
                <SkeletonBlock className="h-4 w-3/4" />
              </div>
              <SkeletonBlock className="h-8 w-14 shrink-0 rounded-full" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function SettingsFieldSkeleton() {
  return (
    <div
      className="mx-auto w-full max-w-2xl space-y-4"
      aria-busy="true"
      aria-label="Loading settings"
    >
      <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-700 dark:bg-gray-800">
        <div className="space-y-3">
          <SkeletonBlock className="h-4 w-full" />
          <SkeletonBlock className="h-4 w-5/6" />
          <SkeletonBlock className="h-12 w-full" />
        </div>
      </div>
    </div>
  );
}
